export function defineRoutes(config) {
    const result = {};
    for (const path of Object.keys(config)) {
        result[path] = createRoute(path);
    }
    return result;
}
export function defineRouteMetadata(_routes, metadata) {
    return metadata;
}
function createRoute(path) {
    return {
        path,
        href: (...args) => {
            const options = args[0];
            let result = path;
            if (options?.path) {
                for (const [key, value] of Object.entries(options.path)) {
                    result = result.replace(`:${key}`, encodeURIComponent(value));
                }
            }
            if (options?.search) {
                const params = new URLSearchParams();
                for (const [key, value] of Object.entries(options.search)) {
                    if (value !== undefined) {
                        if (Array.isArray(value)) {
                            for (const item of value) {
                                params.append(key, String(item));
                            }
                        }
                        else {
                            params.append(key, String(value));
                        }
                    }
                }
                const queryString = params.toString();
                if (queryString) {
                    result += `?${queryString}`;
                }
            }
            return result;
        },
    };
}
//# sourceMappingURL=RouteDef.js.map